// CSS Modules - component class name prefix: NewsList__

<template>
  <div class="ContentTabs__container">
    <template v-if="config.tabs.length === 1">
      <FormFilter
        :config="config.tabs[0]"
        @filtered="displayResults"
        @has-results="displayPagination"
      />
      <div class="columns is-multiline">
        <div
          :key="`oneTab_${resultIndex}`"
          v-for="(result, resultIndex) in displayedResults"
          class="column is-half-tablet is-one-third-desktop"
        >
          <ListTeaser
            :result="result"
            :wtParams="
              config.tabs[0].inlineData.wtParams
                ? config.tabs[0].inlineData.wtParams
                : config.wtParams || {}
            "
          />
        </div>
      </div>
      <Pagination
        :config="config.pagination"
        :results="results.length"
        @update="displayPaginatedResults"
      />
    </template>
    <div v-if="!isMobile && config.tabs.length > 1" class="ContentTabs__tabs">
      <a
        v-for="(tab, tabIndex) in config.tabs.length"
        :key="`tabLink_${tab}`"
        v-on:click="updateTabs(tab)"
        :class="[
          'ContentTabs__tab',
          { ContentTabs__active: activeTab === tab },
          { ContentTabs__disabled: config.tabs[tabIndex].disabled }
        ]"
      >
        {{ config.tabs[tabIndex].title }}
      </a>
      <div
        :class="[
          'ContentTabs__content',
          { ContentTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, tabIndex) in config.tabs.length"
        :key="`tab_${tab}`"
      >
        <template v-if="activeTab === tab">
          <FormFilter
            :config="config.tabs[tabIndex]"
            @filtered="displayResults"
            @has-results="displayPagination"
          />
          <div class="columns is-multiline">
            <div
              :key="'listTeaserContainer_' + resultIndex"
              v-for="(result, resultIndex) in displayedResults"
              class="column is-half-tablet is-one-third-desktop"
            >
              <ListTeaser
                :result="result"
                :wtParams="
                  config.tabs[tabIndex].inlineData.wtParams
                    ? config.tabs[tabIndex].inlineData.wtParams
                    : config.wtParams || {}
                "
              />
            </div>
          </div>
          <Pagination
            :config="config.pagination"
            :results="results.length"
            @update="displayPaginatedResults"
          />
        </template>
      </div>
    </div>
    <div
      v-if="isMobile && config.tabs.length > 1"
      class="ContentTabs__tabs ContentTabs__mobile"
    >
      <div
        v-for="(tab, tabIndex) in config.tabs.length"
        :key="`tabMobile_${tabIndex}`"
      >
        <a
          v-if="!config.tabs[tabIndex].disabled"
          v-on:click="updateTabs(tab)"
          :class="[
            'ContentTabs__tab',
            { ContentTabs__active: activeTab === tab && mobileHidden !== tab }
          ]"
        >
          {{ config.tabs[tabIndex].title }}
        </a>
        <div
          :class="[
            'ContentTabs__content',
            { ContentTabs__activeContent: activeTab === tab && !isMobile },
            {
              ContentTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <template v-if="activeTab === tab">
            <FormFilter
              :config="config.tabs[tabIndex]"
              @filtered="displayResults"
              @has-results="displayPagination"
            />
            <div class="columns is-multiline">
              <div
                v-for="(result, resultIndex) in displayedResults"
                :key="`listTeaserContainerMobile_${tabIndex}_${resultIndex}`"
                class="column is-half-tablet is-one-third-desktop"
              >
                <ListTeaser
                  :result="result"
                  :wtParams="
                    config.tabs[tabIndex].inlineData.wtParams
                      ? config.tabs[tabIndex].inlineData.wtParams
                      : config.wtParams || {}
                  "
                />
              </div>
            </div>
            <Pagination
              :config="config.pagination"
              :results="results.length"
              @update="displayPaginatedResults"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormFilter from "../FormFilter/FormFilter";
import ListTeaser from "../ListTeaser/ListTeaser";
import Pagination from "../Pagination/Pagination";

export default {
  name: "NewsList",
  components: {
    FormFilter,
    ListTeaser,
    Pagination
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isMobile: false,
      activeTab: null,
      mobileHidden: null,
      activeTabPreselected: false,
      results: [],
      displayRange: [0, this.config.pagination.resultsPerPage - 1],
      displayedResults: [],
      hasResults: false
    };
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    initTabs() {
      const queries = window.location.search.substring(1).split("&");
      let queryStringTabId = null;
      if (queries) {
        for (const query of queries) {
          if (query.includes("tab")) {
            queryStringTabId = query.split("=")[1];
          }
        }
      }
      for (const [index, tab] of this.config.tabs.entries()) {
        if (
          (queryStringTabId &&
            queryStringTabId == index + 1 &&
            !tab.disabled) ||
          (tab.active && !tab.disabled)
        ) {
          this.activeTab = index + 1;
          this.activeTabPreselected = true;
        }
      }
      if (!this.activeTabPreselected) {
        this.activeTab = 1;
      }
    },
    updateTabs(tab) {
      const elm = event.currentTarget;
      if (!elm.classList.contains("ContentTabs__disabled")) {
        if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab !== this.mobileHidden
        ) {
          this.mobileHidden = tab;
        } else if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab === this.mobileHidden
        ) {
          this.mobileHidden = null;
        } else if (this.isMobile && this.activeTab !== tab) {
          this.mobileHidden = null;
          this.activeTab = tab;
        } else {
          this.activeTab = tab;
        }
      }
    },
    displayPagination(hasResults) {
      this.hasResults = hasResults;
    },
    displayResults(results) {
      this.results = results;
      this.displayedResults = [];
      for (let i = 0; i < this.results.length; i++) {
        if (i >= this.displayRange[0] && i <= this.displayRange[1]) {
          this.displayedResults.push(this.results[i]);
        } else if (i > this.displayRange[1]) {
          break;
        }
      }
    },
    displayPaginatedResults(displayRange) {
      this.displayRange = displayRange;
      this.displayResults(this.results);
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
    this.initTabs();
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>

<style module lang="scss">
@import "./NewsList.scss";
</style>
